/**
 * @ngdoc directive
 * @name Banner
 * @param $sce
 * @param $timeout
 * @returns {{restrict: string, templateUrl: string, scope: {background: string, title: string, subtitle: string, play: string, showPlay: string, overlay: string}, compile: Function}}
 * @constructor
 */
export default function BannerDirective($sce, $timeout) {
  'ngInject';
  return {
    restrict: "E",
    templateUrl: 'app/ecourse/shared/banner/banner.html',
    scope: {
      colorScheme: "=",
      textColorScheme: "=",
      //Background image
      background: '=',
      //Title of ecourse
      title: '=',
      //Subtitle
      subtitle: '=',
      //The play function
      play: '&',
      //Show the play button
      showPlay: '=',
      //Show the overlay
      overlay: '='
    },
    compile: function ($element, $attrs) {
      //Default attribute value
      
      if (!$attrs.showPlay) {
        $attrs.showPlay = true;
      }

      return {
        //Same as the link function
        post: function ($scope) {
          //When overlay var changes
          $scope.$watch('overlay', function () {
            //If the overlay is truthy
            if ($scope.overlay) {
              //Set some defaults
              let defaultOverlay = {
                //Message serves as a SRC trusted endpoint for html
                message: '',
                //Show or hide the title and subtitle
                hideContent: true,
                //TODO - Make Template more required.
                //The required template for the overlay
                template: undefined
              };
              //Merge defaults giving precidence to incoming object.
              $scope.overlay = Object.assign(defaultOverlay, $scope.overlay);
              //Trust the message as html
              $scope.overlayMessage = $sce.trustAsHtml($scope.overlay.message);
              //Provide the overlay call to action buttons with a way to call methods on the parent scope.
              $scope.overlay.callAction = function (exp) {
                $timeout(function () {
                  //Executle the exp within the context of the parent scope.
                  $scope.$parent.$apply(exp);
                });
              };
              //TODO - Make the template required.
              if ($scope.overlay.template) {
                //Generate and trust the template uri
                $scope.overlay.templateUrl = `app/ecourse/shared/overlays/${$scope.overlay.template}.html`;
              }
            }
          }, true);
        }
      };
    }
  };
}



/** WEBPACK FOOTER **
 ** ./src/app/ecourse/shared/banner/banner.directive.js
 **/